import { Box, type Colors, Icon, Text } from '@factorialco/deprecated-design-system'

interface Props {
  color: Colors
  message: string
}

export default function EnpsAnonymousBanner({ color, message }: Props) {
  return (
    <Box
      gap="s8"
      flexDirection="row"
      paddingY="s12"
      alignItems="center"
      justifyContent="center"
      height="s48"
      background={color}
    >
      <Icon.Medium color="grey800" icon="info-circle-line" />
      <Text.Normal size="300" weight="medium" color="grey800">
        {message}
      </Text.Normal>
    </Box>
  )
}
